/**
 * @file ShipmentCarrierOverride.tsx
 * @description Свёрнутый блок «Изменить перевозчика» в сайдбаре новой
 * отгрузки (2026-09-22). Согласованный перевозчик — правило, замена —
 * исключение: поля появляются только по явному клику либо сразу, когда
 * условий доставки нет. Трек руками — только у перевозчиков без интеграции.
 */

import { isManualTrackCarrier, SHIPMENT_CARRIER_LABEL, type ShipmentCarrier } from "../../lib/api-orders";
import { Input } from "../ui/input";
import { Label } from "../ui/label";
import { SelectField } from "../ui/SelectField";

interface Props {
  open: boolean;
  carrier: ShipmentCarrier;
  trackNumber: string;
  disabled?: boolean;
  onOpen: () => void;
  onCarrier: (carrier: ShipmentCarrier) => void;
  onTrackNumber: (value: string) => void;
}

const CARRIER_OPTIONS = Object.entries(SHIPMENT_CARRIER_LABEL).map(([value, label]) => ({
  value,
  label,
}));

export function ShipmentCarrierOverride({
  open,
  carrier,
  trackNumber,
  disabled,
  onOpen,
  onCarrier,
  onTrackNumber,
}: Props) {
  if (!open) {
    return (
      <button
        type="button"
        className="min-h-11 self-start text-sm text-primary underline-offset-4 hover:underline"
        onClick={onOpen}
      >
        Изменить перевозчика
      </button>
    );
  }
  return (
    <div className="flex flex-col gap-3">
      <div className="flex flex-col gap-1.5">
        <Label htmlFor="sh-carrier">Перевозчик</Label>
        <SelectField
          id="sh-carrier"
          ariaLabel="Перевозчик"
          value={carrier}
          onChange={(v) => onCarrier(v as ShipmentCarrier)}
          options={CARRIER_OPTIONS}
          disabled={disabled}
        />
      </div>
      {isManualTrackCarrier(carrier) ? (
        <div className="flex flex-col gap-1.5">
          <Label htmlFor="sh-track">Трек-номер (можно позже)</Label>
          <Input
            id="sh-track"
            className="min-h-12"
            value={trackNumber}
            onChange={(e) => onTrackNumber(e.target.value)}
            placeholder="Например, 80091234567890"
            disabled={disabled}
          />
        </div>
      ) : (
        <p className="text-xs text-on-surface-variant">
          Трек-номер присвоит СДЭК после передачи заявки — вводить его вручную не нужно.
        </p>
      )}
    </div>
  );
}
